module.exports = __webpack_public_path__ + "img/register-btn.09ea5779.png";